// extracted by mini-css-extract-plugin
module.exports = {"country":"Country_country__1hT3S","info":"Country_info__2pzrl","detail":"Country_detail__2I--4","flag":"Country_flag__2gUi4","activities":"Country_activities__RnsXK"};